// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2SCip","inputWrap":"styles_inputWrap__MdwD4","input":"styles_input__1gUef"};